
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Minibusonrent() {



    const cardData =
    {
        keyword: 'Mini Bus on Rent',
        heading: 'Meghana Cab :Mini Bus on Rent in Pune',
        headingDescription: 'Meghana Cab offersMini Bus on Rent in Pune services, ideal for group travel, corporate events, wedding transportation, school trips, and outstation tours. Our mini buses are available in various seating capacities such as 18, 20, 22, and 26 seaters, equipped with pushback seats, air conditioning, spacious interiors, and ample luggage space. Whether you are planning a local journey or a long-distance tour to destinations like Mahabaleshwar, Goa, Shirdi, or Lonavala, our mini buses ensure comfort, safety, and convenience. With experienced drivers, transparent pricing, and 24/7 customer support, book yourMini Bus on Rent in Pune with Meghana Cab for a reliable and enjoyable group travel experience.',


        top: 'Top Places to Visit in Pune with Meghana Cab',

"topPlaces": [
   {
    "title": "Osho Ashram (Meditation Resort)",
    "description": "Nestled in lush Koregaon Park, this global meditation centre promotes wellness through guided meditations, yoga, therapies, and silent retreats. Housed in serene halls with beautifully maintained gardens, it provides a space for introspection and rejuvenation." 
  },
    {
    "title": "Sinhagad Fort",
    "description": "Perched at 1,317 m on the Sahyadri range, this ancient hill fortress—famed for the 1670 Battle of Sinhagad—offers rugged treks, two main gateways (Pune & Kalyan Darwaza), Tanaji Malusare’s memorial, and sweeping vistas of the Deccan Plateau. It’s a beloved weekend trek with food stalls serving local fare." 
  },
    {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 as the seat of the Maratha Peshwas, this iconic fortification features grand teak gateways, granite walls, ornate fountains, and remnants of its former glory. Despite a destructive fire in 1828, the five surviving gates—like the Delhi and Mastani Darwaza—and the palace ruins offer a journey into Maratha power and intrigue, often brought to life during the evening light-and-sound show." 
  },
  {
    "title": "Aga Khan Palace",
    "description": "Constructed in 1892 with Italian arches and set amidst sprawling lawns, this palatial structure served both famine relief and later the Indian freedom struggle—Mahatma Gandhi and his family were interned here. Now a museum, it preserves Gandhi’s personal items and the samadhis of Kasturba Gandhi and Mahadev Desai, echoing India’s fight for independence." 
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "An 8th‑century monolithic rock‑cut Shiva temple carved from basalt, this subterranean sanctum includes a circular Nandi mandapa with intricately carved pillars and a unique ‘underworld’ symbolism, all nestled within a peaceful urban heritage setting." 
  },
  {
    "title": "Dagdusheth Halwai Ganapati Temple",
    "description": "One of Pune’s most celebrated sacred sites, this temple houses a lavishly adorned gold Ganesh idol and draws devotees year‑round. During Ganesh Chaturthi, its vibrant rituals, processions, and communal spirit make it a cultural highlight." 
  },
  {
    "title": "Parvati Hill & Temple",
    "description": "Pune’s second‑highest hill at ~2,100 ft, crowned by the historic Peshwa-era Parvati Temple. A 103-step climb rewards visitors with rooftop city views, a small museum, and serene gardens—popular at sunrise and for spiritual solace." 
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Housing 20,000+ artifacts—ranging from decorative arts to musical instruments—this museum offers a vivid window into daily life in historical India. It recently introduced geofenced multilingual audio guides across its eight galleries. " 
  },
  {
    "title": "Shinde Chhatri",
    "description": "A memorial dedicated to Maratha warrior Mahadji Shinde (d.1794), featuring Rajasthani-style carved pavilions, colored glass windows, and serene courtyards. It marks both his cremation spot and enduring legacy." 
  },
  {
    "title": "Rajiv Gandhi Zoological Park (Katraj Zoo)",
    "description": "Spanning 130 acres at Pune’s edge, this family-friendly park includes a zoo, snake park, aviary, and botanical sections. It combines wildlife conservation with educational exhibits and picnic spaces." 
  }
],

"services": [
  {
    "name": "Mini Bus Hire Pune",
    "description": "Hire a comfortable and well-maintained mini bus in Pune for group travel, events, or corporate tours. Ideal for medium-sized groups, our mini buses offer spacious interiors, professional drivers, and reliable service across local and outstation routes."
  },
  {
    "name": "Book Mini Bus for Travel Pune",
    "description": "Book a mini bus for smooth travel in Pune and nearby destinations. Whether it’s a family trip, company outing, or pilgrimage, our easy booking process and quality vehicles ensure everyone travels comfortably and on schedule."
  },
  {
    "name": "18-Seater Mini Bus Pune",
    "description": "Our 18-seater mini bus in Pune is perfect for small groups seeking a safe and comfortable travel option. With ample seating, AC, and experienced drivers, it’s a popular choice for school trips, office outings, and day tours."
  },
  {
    "name": "AC Mini Bus Rental Pune",
    "description": "Travel in comfort with our air-conditioned mini bus rental service in Pune. Perfect for longer rides or hot days, our buses offer efficient cooling, reclining seats, and smooth performance for both local and outstation journeys."
  },
  {
    "name": "Mini Bus for Outstation Pune",
    "description": "Planning a group getaway outside Pune? Our outstation mini bus rental service offers dependable vehicles with expert drivers for safe, convenient, and enjoyable journeys to destinations across Maharashtra and beyond."
  },
  {
    "name": "Pune to Mumbai Mini Bus Hire",
    "description": "Hire a mini bus for hassle-free travel between Pune and Mumbai. Suitable for business teams, large families, or tour groups, our service ensures on-time travel with comfort, luggage space, and a stress-free highway experience."
  },
  {
    "name": "Corporate Mini Bus Service Pune",
    "description": "Organize team transportation with ease using our corporate mini bus rental in Pune. Our professional service is ideal for office commutes, seminars, company events, and employee outings, offering timely pickup and safe travel."
  },
  {
    "name": "School Trip Mini Bus Pune",
    "description": "Ensure safe and comfortable student transportation with our school trip mini buses in Pune. Our fleet meets all safety standards and includes experienced, verified drivers to make field trips and educational tours worry-free."
  },
  {
    "name": "Wedding Event Mini Bus Pune",
    "description": "Manage guest transportation for weddings in Pune with our mini bus hire. Perfect for moving guests between venues, our clean and air-conditioned buses make sure everyone arrives on time, comfortably and in style."
  },
  {
    "name": "Mini Bus for Group Tours Pune",
    "description": "Explore Pune and nearby tourist spots with our group tour mini buses. Designed for comfort and long-duration travel, these buses feature ample seating, cooling systems, and luggage storage for a relaxed sightseeing experience."
  },
  {
    "name": "Budget Mini Bus Rental Pune",
    "description": "Get great value on group transportation with our budget mini bus rental services in Pune. We provide clean, reliable, and fuel-efficient vehicles that suit school groups, families, and companies looking for affordable solutions."
  },
  {
    "name": "Luxury Mini Bus Hire Pune",
    "description": "Upgrade your travel with our luxury mini bus rentals in Pune. With plush seating, advanced amenities, and professional chauffeurs, this service is ideal for VIP movements, weddings, or executive group tours."
  },
  {
    "name": "Mini Bus Booking for Picnics Pune",
    "description": "Planning a group picnic near Pune? Book our mini bus service for an enjoyable and worry-free outing. Our buses accommodate your entire group, with space for supplies, music systems, and friendly drivers to enhance the fun."
  },
  {
    "name": "20-Seater Mini Bus Pune",
    "description": "Need a bit more space? Our 20-seater mini bus in Pune is perfect for slightly larger groups, providing ample comfort for longer journeys, group functions, or outstation tours with full safety and reliability."
  },
  {
    "name": "Pune Airport Mini Bus Transfer",
    "description": "Transport groups to and from Pune Airport easily with our mini bus airport transfer service. Ideal for weddings, conferences, and tourist groups, our drivers ensure prompt arrivals and departures with no delays."
  }
],
"tableData": [
  ["Mini Bus Hire Pune", "Book Mini Bus for Travel Pune"],
  ["18-Seater Mini Bus Pune", "AC Mini Bus Rental Pune"],
  ["Mini Bus for Outstation Pune", "Pune to Mumbai Mini Bus Hire"],
  ["Corporate Mini Bus Service Pune", "School Trip Mini Bus Pune"],
  ["Wedding Event Mini Bus Pune", "Mini Bus for Group Tours Pune"],
  ["Budget Mini Bus Rental Pune", "Luxury Mini Bus Hire Pune"],
  ["Mini Bus Booking for Picnics Pune", "20-Seater Mini Bus Pune"],
  ["Pune Airport Mini Bus Transfer", ""]
],







"whychoose": [
    {
        "WhyChooseheading": "Spacious Mini Bus Rentals for Group Travel",
        "WhyChoosedescription": "Meghana Cab provides comfortable and spacious mini bus rentals, perfect for large groups, corporate events, school trips, and family outings. Our mini buses can accommodate 20 to 30 passengers, offering ample space and comfort for everyone on board."
    },
    {
        "WhyChooseheading": "Well-Maintained and Hygienic Vehicles",
        "WhyChoosedescription": "All our mini buses undergo regular maintenance and thorough cleaning to ensure a safe and hygienic travel environment. Equipped with air-conditioning and comfortable seating, our vehicles provide a pleasant journey regardless of the distance."
    },
    {
        "WhyChooseheading": "Professional and Experienced Drivers",
        "WhyChoosedescription": "Our drivers are trained, courteous, and familiar with various routes to ensure safe and timely travel. They prioritize passenger safety and comfort, making your journey smooth and enjoyable."
    },
    {
        "WhyChooseheading": "Transparent and Affordable Pricing",
        "WhyChoosedescription": "We offer competitive pricing for mini bus rentals with no hidden charges. Our rates include fuel, tolls, driver allowances, and taxes, providing full clarity and excellent value for your group travel needs."
    },
    {
        "WhyChooseheading": "Flexible Booking and Customized Itineraries",
        "WhyChoosedescription": "Whether you need the mini bus for a day, multiple days, or special events, our rental options are flexible and tailored to your requirements. Customize pickup and drop locations, routes, and stops to suit your itinerary."
    },
    {
        "WhyChooseheading": "Ideal for Schools, Corporate Events, and Large Gatherings",
        "WhyChoosedescription": "Our mini buses are perfect for transporting students, employees, or large groups to events, outings, or religious pilgrimages. Experience hassle-free group travel with ample space and comfort."
    },
    {
        "WhyChooseheading": "24/7 Booking Support and Customer Service",
        "WhyChoosedescription": "Book your mini bus rental anytime with our round-the-clock customer support. Our team is available to assist with reservations, changes, or special requests, ensuring a seamless and stress-free booking process."
    },
    {
        "WhyChooseheading": "Safety and Comfort Assured",
        "WhyChoosedescription": "Safety is our utmost priority. Our mini buses are equipped with safety features and driven by professional drivers who adhere to all safety protocols, providing you with a secure and comfortable journey."
    }
]






























    }

const faqData = [
    {
        question: "How can I rent a mini bus with Meghana Cab?",
        answer: "You can book a mini bus by calling Meghana Cab at +91 9075462128 or through our website for easy and fast booking."
    },
    {
        question: "What is the seating capacity of your mini buses?",
        answer: "Our mini buses comfortably seat between 20 to 30 passengers, ideal for large groups and corporate travel."
    },
    {
        question: "Are Meghana Cab drivers experienced in driving mini buses?",
        answer: "Yes, our drivers are skilled and experienced in handling mini buses to ensure a safe and comfortable journey."
    },
    {
        question: "Can I rent a mini bus for local or outstation trips?",
        answer: "Yes, mini buses are available for both local city travel and outstation journeys."
    },
    {
        question: "Does the rental fare include fuel, tolls, and driver charges?",
        answer: "Our fares include fuel, tolls, and driver charges. Additional waiting time or parking fees may incur extra charges."
    },
    {
        question: "Are the mini buses sanitized before every trip?",
        answer: "Yes, all mini buses are thoroughly sanitized before each journey to ensure passenger safety."
    },
    {
        question: "Is the mini bus rental service available 24/7?",
        answer: "Yes, Meghana Cab offers round-the-clock mini bus rental services."
    },
    {
        question: "Can I request stops for meals or sightseeing during the trip?",
        answer: "Yes, stops can be arranged upon request. Please inform us when booking."
    },
    {
        question: "What payment methods are accepted for mini bus rentals?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash."
    },
    {
        question: "How do I contact Meghana Cab to rent a mini bus?",
        answer: "Call us anytime at +91 9075462128 to book your mini bus or get assistance."
    }
];

const testimonialsData = [
    {
        name: 'Mr. Deepak Patil',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“The mini bus rental was perfect for our corporate outing. Spacious and comfortable ride with a professional driver.”',
    },
    {
        name: 'Ms. Richa Deshmukh',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Excellent service and well-maintained mini bus. Meghana Cab made our group travel hassle-free.”',
    },
];






    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];






const miniBusSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Mini Bus on Rent in Pune",
  "image": "https://www.meghanacabs.com/assets/images/mini-bus-pune.jpg",
  "description": "Rent a Mini Bus in Pune for group tours, corporate events, school trips, weddings, and airport transfers. Choose from 18-seater and 20-seater AC Mini Buses for comfortable travel.",
  "provider": {
    "@type": "Organization",
    "name": "Meghana Cabs",
    "url": "https://www.meghanacabs.com"
  },
  "serviceType": [
    "Mini Bus Hire Pune",
    "Book Mini Bus for Travel Pune",
    "18-Seater Mini Bus Pune",
    "AC Mini Bus Rental Pune",
    "Mini Bus for Outstation Pune",
    "Pune to Mumbai Mini Bus Hire",
    "Corporate Mini Bus Service Pune",
    "School Trip Mini Bus Pune",
    "Wedding Event Mini Bus Pune",
    "Mini Bus for Group Tours Pune",
    "Budget Mini Bus Rental Pune",
    "Luxury Mini Bus Hire Pune",
    "Mini Bus Booking for Picnics Pune",
    "20-Seater Mini Bus Pune",
    "Pune Airport Mini Bus Transfer"
  ],
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  }
};







    return (
        <div>
<Helmet>
  <title>Mini Bus on Rent in Pune | Meghana Cabs</title>
  <meta
    name="description"
    content="Rent a Mini Bus in Pune for group tours, corporate events, school trips, weddings, and airport transfers. Choose from 18-seater and 20-seater AC Mini Buses for comfortable travel."
  />
  <meta
    name="keywords"
    content="Mini Bus Hire Pune, Book Mini Bus for Travel Pune, 18-Seater Mini Bus Pune, AC Mini Bus Rental Pune, Mini Bus for Outstation Pune, Pune to Mumbai Mini Bus Hire, Corporate Mini Bus Service Pune, School Trip Mini Bus Pune, Wedding Event Mini Bus Pune, Mini Bus for Group Tours Pune, Budget Mini Bus Rental Pune, Luxury Mini Bus Hire Pune, Mini Bus Booking for Picnics Pune, 20-Seater Mini Bus Pune, Pune Airport Mini Bus Transfer"
  />
  <script type="application/ld+json">
    {JSON.stringify(miniBusSchema)}
  </script>
</Helmet>



            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/54.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                             <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Minibusonrent;